@if (embedded) {
  <!-- Les menus de la barre du haut, sans leur bouton : seule une rubrique de la coque les
       ouvre. inert les retire du clavier et des technologies d'assistance ; le menu ouvert,
       lui, vit dans la couche des surimpressions, hors de ce bloc. -->
  <div class="embedded-menus" inert>
    <app-menu-company></app-menu-company>
    <app-menu-salary-scale></app-menu-salary-scale>
    @if (!demo) {
      <app-menu-anomalies></app-menu-anomalies>
    }
  </div>
  <!-- La bascule d'affichage doit rester visible : elle reste dans la page (contrat, § 2). -->
  <div class="embedded-actions">
    <app-layout-buttons></app-layout-buttons>
  </div>
} @else {
  <app-navbar>
    <div left-side>
      <button mat-icon-button aria-label="Page d'accueil" matTooltip="Accueil" routerLink="/">
        <svg lucideHouse class="vanex-gold"></svg>
      </button>
      <app-menu-company></app-menu-company>
      <app-menu-salary-scale></app-menu-salary-scale>
      @if (!demo) {
        <app-menu-anomalies></app-menu-anomalies>
      }
      <app-menu-tours></app-menu-tours>
      <app-menu-settings></app-menu-settings>
    </div>
    <app-layout-buttons center></app-layout-buttons>

    <app-menu-user-button-item menu-user-items> </app-menu-user-button-item>
  </app-navbar>
}
